import { EBenefitStatus, IBenefit, IGroupConfigurationData, IGroupNumber, IPlan } from "model/FlexibleAttributeModel";
import { BaseJsonTransformer } from "./IJsonTransformer";

export class RemoveCancelledDataTransformer extends BaseJsonTransformer {
    readonly cancelledIds = new Map<string, any>();

    async before(json: IGroupConfigurationData): Promise<void> {
        this.cancelledIds.clear();
    }

    async transformBenefit(benefit: IBenefit): Promise<boolean | void> {
        if (benefit.status?.value === EBenefitStatus.Cancelled) {
            if (benefit.id)
                this.cancelledIds.set(benefit.id, benefit);

            // return true to indicate removal
            return true;
        }

        return false;
    }

    async transformGroupNumber(groupNumber: IGroupNumber): Promise<boolean | void> {
        if (groupNumber.status?.value === EBenefitStatus.Cancelled) {
            if (groupNumber.id)
                this.cancelledIds.set(groupNumber.id, groupNumber);

            // return true to indicate removal
            return true;
        }

        return false;
    }

    async transformPlan(plan: IPlan): Promise<boolean | void> {
        // NOTE: this relies on the order in which the transforms are applied
        for (let i = plan.benefitRefs.length - 1; i >= 0; i--) {
            let ref = plan.benefitRefs[i];
            if (this.cancelledIds.has(ref.id)) {
                plan.benefitRefs.splice(i, 1);
            }
        }
    }
}